<ion-header class="ion-header-set-password">
  <ion-toolbar>
    <div class="header-grid">
      <div class="main-logo-sec">
        <img src="assets/images/eZintegration-black-logo.svg">
      </div>
    </div>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="container">
    <div class="bg-grid">
      <div class="grid-container">
        <div class="grid-content">
          <div class="company-logo-sec">
            <img src="assets/images/bizdata-header-logo.png">
          </div>
           
          <mat-card class="p-0">
            <mat-card-content>
              <div class="signup-sec">
                Reset your Password
              </div>
              <div class="content-grid">            
                <div class="img">
                  <div class="imgtext"><h2> Rest Password</h2></div>
                </div>
                <div class="col-spacing">
                  <div class="main-logo-sec">
                    <img src="assets/images/eZintegration-black-logo.svg">
                  </div>               
                  <div class="form-container">
                    <div class="empd">Enter new password for {{regemail}}</div> 
                    <form [formGroup]="setPasswordform" (ngSubmit)="onSetPasswordSubmit()">
                      <div class="reset-password">          
                        <mat-form-field appearance="outline" *ngIf="isPwdExp">
                          <mat-label>Old Password</mat-label>
                            <input type="password" formControlName="oldPassword" matInput placeholder="Old Password" required>
                            <mat-error *ngIf="setPasswordControls.oldPassword.hasError('required') || setPasswordControls.oldPassword.hasError('minlength') || setPasswordControls.newPassword.hasError('hasNumber') || setPasswordControls.newPassword.hasError('hasUpperCase') || setPasswordControls.newPassword.hasError('hasSmallCase') || setPasswordControls.newPassword.hasError('hasSpecialCharacters')">Password must have atleast 8 Characters, 1 Number, 1 Special Character, 1 Lowercase Character, 1 Upper Character.</mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                          <mat-label>New Password</mat-label>
                            <input [type]="hide ? 'password' : 'text'" formControlName="newPassword" matInput placeholder="New Password" required>
                            <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            <mat-error *ngIf="setPasswordControls.newPassword.hasError('required') || setPasswordControls.newPassword.hasError('minlength') || setPasswordControls.newPassword.hasError('hasNumber') || setPasswordControls.newPassword.hasError('hasUpperCase') || setPasswordControls.newPassword.hasError('hasSmallCase') || setPasswordControls.newPassword.hasError('hasSpecialCharacters')">Password must have atleast 8 Characters, 1 Number, 1 Special Character, 1 Lowercase Character, 1 Upper Character.</mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                          <mat-label>Confirm Password</mat-label>
                          <input type="password" formControlName="confirmPassword" matInput placeholder="Confirm Password" required>
                          <!-- <mat-error *ngIf="submitted && setPasswordControls.confirmPassword.hasError('required')">Password Required. </mat-error> -->
                          <mat-error *ngIf="setPasswordControls.confirmPassword.hasError('NoPassswordMatch')">Password do not match. </mat-error>
                        </mat-form-field>
                      </div> 
                      <div class="btn-grid">
                        <button mat-raised-button type="submit" class="btn-set-password">Change</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div> 
            
            </mat-card-content>
          </mat-card>
          <app-powered-by-footer></app-powered-by-footer>
        </div>
      </div>
    </div>
  </div>
</ion-content>

